import { lazy } from 'react';

import { Loadable } from '../../../../utils';

export const Invoices = Loadable(lazy(() => import('../containers/InvoicesContainer')));

export const InvoiceCreate = Loadable(lazy(() => import('../containers/InvoiceCreateContainer')));
